module.exports = __webpack_public_path__ + "static/media/UserManagement_color.fcebb9f8.svg";